<template>
	<div class="message-preview message-wrapper">
		<div class="message-container">
			<ProfilePic v-if="user" :user="user" size="46px" class="message-img" />
			<div class="message">
				<MessageHeader :user="user" :date="message.created_at" />
				<div class="message-text">
					<MessageMedia :message="message" />

					<MessageText
						v-if="!hasPoll"
						:message="message"
						:currentUser="store.auth.user"
					/>

					<PollCard
						v-if="hasPoll"
						:pollId="message.poll_id"
						class="message-poll-card"
					/>

					<TaskCard
						v-if="showTaskCard"
						:task="message.task"
						:systemmessageparts="message.systemmessageparts"
						:removed="isTaskRemoved"
					/>

					<MeetingEndedCard
						v-if="lsStoppedMessage"
						:videosession="videosession"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store, { getUser, getVideosession } from '../../store'
import { ProfilePic } from '../common'
import MessageText from './MessageText'
import MessageMedia from './MessageMedia'
import MeetingEndedCard from './MeetingEndedCard'
import MessageHeader from './MessageHeader'
import TaskCard from './TaskCard'
import PollCard from '@/components/Polls/PollCard'

export default {
	name: 'MessagePreview',

	components: {
		ProfilePic,
		MessageText,
		MessageMedia,
		MeetingEndedCard,
		MessageHeader,
		TaskCard,
		PollCard,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data() {
		return { store }
	},

	computed: {
		user() {
			return this.message?.user || getUser(this.message?.user_id)
		},

		hasPoll() {
			return !!this.message.poll_id
		},

		showTaskCard() {
			if (
				this.message.systemevent === 'TASK_ASSIGNED' ||
				this.message.systemevent === 'TASK_DUEDATECHANGED'
			) {
				return !!this.message.task
			}
			return !!(this.message.task && !this.message.systemevent)
		},

		isTaskRemoved() {
			if (this.message.task_id) {
				return !this.message.task
			}
			return false
		},

		lsStoppedMessage() {
			return this.message.systemevent === 'VIDEOSESSION_STOPPED'
		},

		videosession() {
			return (
				this.message?.meeting || getVideosession(this.message?.videosession_id)
			)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.message-preview {
	pointer-events: none;
	padding-left: 10px;
	padding-right: 16px;
	padding-top: 4px;
	padding-bottom: 4px;

	:deep(.message-container) {
		position: relative;
		display: flex;
		align-items: flex-start;
	}

	:deep(.message-img) {
		flex-shrink: 0;
		margin-top: 0;
		margin-right: 6px;
		border: 4px solid var(--neutral-0);
	}

	:deep(.message) {
		width: 100%;
		flex-grow: 1;
		min-width: 0;
		margin-left: 0;

		.message-header {
			display: flex;
			align-items: center;
			margin-bottom: 4px;
			gap: 8px;

			.message-name {
				font-family: Avenir-Heavy;
				font-size: 15px;
				color: var(--neutral-800);
				display: inline-block;
			}
		}
	}

	:deep(.message-text) {
		@include fontFamily(400);
		font-size: 17px;
		color: var(--neutral-800);
		width: 100%;
		overflow-wrap: break-word;
		word-break: break-word;
	}
}
</style>
